export const FTE_CONDITION_OPTIONS = [
  {
    value: "always",
    label: "Always",
    description: "Applies to all properties",
  },
  {
    value: "serviceStyle:luxury",
    label: "Luxury Style",
    description: "Only luxury properties",
  },
  {
    value: "serviceStyle:balanced",
    label: "Balanced Style",
    description: "Only balanced properties",
  },
  {
    value: "serviceStyle:efficient",
    label: "Efficient Style",
    description: "Only efficient properties",
  },
  {
    value: "hasRestaurant:true",
    label: "Has Restaurant",
    description: "Properties with restaurant",
  },
  {
    value: "hasRestaurant:false",
    label: "No Restaurant",
    description: "Properties without restaurant",
  },
  {
    value: "hasBar:true",
    label: "Has Bar",
    description: "Properties with bar",
  },
  {
    value: "hasBar:false",
    label: "No Bar",
    description: "Properties without bar",
  },
  {
    value: "hasSpa:true",
    label: "Has Spa",
    description: "Properties with spa",
  },
  {
    value: "hasSpa:false",
    label: "No Spa",
    description: "Properties without spa",
  },
  {
    value: "hasPool:true",
    label: "Has Pool",
    description: "Properties with pool",
  },
  {
    value: "hasPool:false",
    label: "No Pool",
    description: "Properties without pool",
  },
  {
    value: "roomCount:gte:50",
    label: "Rooms ≥ 50",
    description: "Large properties",
  },
  {
    value: "roomCount:gte:30",
    label: "Rooms ≥ 30",
    description: "Medium-large properties",
  },
  {
    value: "roomCount:lte:30",
    label: "Rooms ≤ 30",
    description: "Small-medium properties",
  },
] as const;
